import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "debug-info" }
const _hoisted_2 = { class: "debug-info__ota" }

import { computed } from 'vue'
import { BfButton, ButtonType } from '@finetic/bikefitting-ui'
import { storeToRefs } from 'pinia'
import { useMqttStore } from '@/store/mqttStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { usePositionStore } from '@/store/positionStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'
import { MqttTopic } from '@/mqttDefinitions/topics'


export default /*@__PURE__*/_defineComponent({
  __name: 'DebugInfo',
  setup(__props) {

const { t } = useI18n()

const mqttStore = useMqttStore()
const preferenceStore = usePreferenceStore()
const positionStore = usePositionStore()
const measurementStore = useMeasurementStore()

const { client, connected, doSubscribe, doRawPublish } = mqttStore
const { getRawValueOnTopic } = storeToRefs(mqttStore)
const { hasFitbike, hasPositioningMotors, hasXYTool } = preferenceStore
const {
  isCalibrated,
  isLatestMeasurementCalibrated,
  startPosition,
  positionOffset,
  positionOffsetGear,
  positionDeviation,
  motorPosition,
  measuredPosition,
  absolutePosition,
  positionChange,
} = positionStore
const { measurements } = measurementStore

const otaTopic = MqttTopic.CONTROLLER_OTA_UPDATE
const otaSetting = computed(
  () => (getRawValueOnTopic.value(otaTopic) as any) ?? {},
)

const updateOta = (enable: boolean) => {
  doRawPublish(
    enable ? MqttTopic.CONTROLLER_OTA_SET : MqttTopic.CONTROLLER_OTA_UNSET,
    JSON.stringify({}),
    client,
  )
}

doSubscribe(otaTopic, client)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.debug.ota')), 1),
      _createElementVNode("pre", null, "Current status: " + _toDisplayString(otaSetting.value.ota ? 'Enabled' : 'Disabled'), 1),
      (!otaSetting.value.ota)
        ? (_openBlock(), _createBlock(_unref(BfButton), {
            key: 0,
            type: _unref(ButtonType).Outlined,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateOta(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('app.fitbike.ota.enable')), 1)
            ]),
            _: 1
          }, 8, ["type"]))
        : (_openBlock(), _createBlock(_unref(BfButton), {
            key: 1,
            type: _unref(ButtonType).Outlined,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateOta(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('app.fitbike.ota.disable')), 1)
            ]),
            _: 1
          }, 8, ["type"]))
    ]),
    _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.debug.mqttStore')), 1),
    _createElementVNode("pre", null, "connected: " + _toDisplayString(_unref(connected)), 1),
    _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.debug.bikeStore')), 1),
    _createElementVNode("pre", null, "hasFitbike: " + _toDisplayString(_unref(hasFitbike)), 1),
    _createElementVNode("pre", null, "hasPositioningMotors: " + _toDisplayString(_unref(hasPositioningMotors)), 1),
    _createElementVNode("pre", null, "hasXYTool: " + _toDisplayString(_unref(hasXYTool)), 1),
    _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.debug.positionStore')), 1),
    _cache[2] || (_cache[2] = _createElementVNode("h4", null, "isCalibrated", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(isCalibrated)), 1),
    _cache[3] || (_cache[3] = _createElementVNode("h4", null, "isLatestMeasurementCalibrated", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(isLatestMeasurementCalibrated)), 1),
    _cache[4] || (_cache[4] = _createElementVNode("h4", null, "startPosition", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(startPosition)), 1),
    _cache[5] || (_cache[5] = _createElementVNode("h4", null, "positionOffset", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(positionOffset)), 1),
    _cache[6] || (_cache[6] = _createElementVNode("h4", null, "positionOffsetGear", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(positionOffsetGear)), 1),
    _cache[7] || (_cache[7] = _createElementVNode("h4", null, "positionDeviation", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(positionDeviation)), 1),
    _cache[8] || (_cache[8] = _createElementVNode("h4", null, "motorPosition", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(motorPosition)), 1),
    _cache[9] || (_cache[9] = _createElementVNode("h4", null, "measuredPosition", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(measuredPosition)), 1),
    _cache[10] || (_cache[10] = _createElementVNode("h4", null, "absolutePosition", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(absolutePosition)), 1),
    _cache[11] || (_cache[11] = _createElementVNode("h4", null, "positionChange", -1)),
    _createElementVNode("pre", null, _toDisplayString(_unref(positionChange)), 1),
    _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.debug.measurementStore')), 1),
    _createElementVNode("pre", null, "measurements (" + _toDisplayString(_unref(measurements).length) + "): " + _toDisplayString(_unref(measurements)), 1)
  ]))
}
}

})